import React, { forwardRef, useContext, useEffect, useMemo } from 'react';
import clsx from 'clsx';
import styles from './styles/modal-header.module.css';
import { ModalContext, ScrollContext } from './modal-context';
import { Typography } from '../typography';
import { Caption } from '../caption';
/**
 * `<ModalHeader>` - Обёртка для контента хэдера модального окна.
 * Предоставляет стили для контента.
 */
export const ModalHeader = /*#__PURE__*/forwardRef(function ModalHeader({
  className = '',
  title,
  titleMobileType = 'title',
  label,
  ...props
}, ref) {
  const {
    variant = 'simple',
    changeContextTitleType,
    sticky
  } = useContext(ModalContext);
  const {
    scrollTop
  } = useContext(ScrollContext);
  const modalHeaderClass = useMemo(() => clsx(styles.modalHeader, styles[variant], scrollTop ? styles.onScroll : '', sticky ? styles.sticky : '', !title && !label ? styles.emptyHeader : '', !title ? styles.emptyMobileHeader : '', className), [variant, scrollTop, sticky, title, label, className]);
  const renderTitleMobile = useMemo(() => {
    const titleClassName = clsx(styles.title, styles.mobile);
    if (!title) return null;
    if (titleMobileType === 'title') {
      return /*#__PURE__*/React.createElement(Typography, {
        as: "h3",
        variant: "h3",
        className: titleClassName,
        "data-testid": "modal_title-mobile-typo"
      }, title);
    }
    return /*#__PURE__*/React.createElement(Caption, {
      message: title,
      className: titleClassName,
      "data-testid": "modal_title-mobile-caption"
    });
  }, [title, titleMobileType]);
  useEffect(() => {
    if (changeContextTitleType) {
      changeContextTitleType(titleMobileType);
    }
  }, [titleMobileType, changeContextTitleType]);
  return /*#__PURE__*/React.createElement("div", {
    className: modalHeaderClass,
    ref: ref,
    ...props
  }, /*#__PURE__*/React.createElement(Caption, {
    message: label,
    className: styles.label
  }), /*#__PURE__*/React.createElement(Typography, {
    as: "h2",
    variant: "h2",
    className: clsx(styles.title, styles.desktop)
  }, title), renderTitleMobile);
});